import { PlusOutlined } from "@ant-design/icons";
import { Fragment } from "react";

export const SocialFootballView = ({ SocailData }: any) => {
  return (
    <Fragment>
      <div className="plsection">
        <div className="head">
          <h3>Joined Players</h3>
          <label htmlFor="">{SocailData.level_title}</label>
        </div>
        <div className="plr_list plr_list03">
          <div className="cell_wrap">
            <h2>Team A ({SocailData?.NoOfPlayerTeamA})</h2>
            <div className="cell">
              {Array.from({ length: SocailData?.NoOfPlayerTeamA || 0 }).map(
                (_, index) => {
                  const teamAPlayers =
                    SocailData?.player_list.filter(
                      (res: any) => res.team === "A"
                    ) || [];
                  const player = teamAPlayers[index];

                  if (player) {
                    return (
                      <div className="cellsub" key={index}>
                        <div className="media">
                          <img
                            src={
                              player.image_url ||
                              "https://static-00.iconduck.com/assets.00/profile-default-icon-512x511-v4sw4m29.png"
                            }
                            alt=""
                          />
                        </div>
                        <h3>{player?.player_name}</h3>
                      </div>
                    );
                  } else {
                    return (
                      <div className="cellsub add_bydef" key={index}>
                        <PlusOutlined />
                      </div>
                    );
                  }
                }
              )}
            </div>
          </div>
          <div className="cell_wrap">
            <h2>Team B ({SocailData?.NoOfPlayerTeamB})</h2>
            <div className="cell">
              {Array.from({ length: SocailData?.NoOfPlayerTeamB || 0 }).map(
                (_, index) => {
                  const teamBPlayers = SocailData?.player_list.filter(
                    (res: any) => res.team === "B"
                  );
                  const player = teamBPlayers[index];
                  if (player) {
                    return (
                      <div className="cellsub" key={index}>
                        <div className="media">
                          <img
                            src={
                              player.image_url ||
                              "https://static-00.iconduck.com/assets.00/profile-default-icon-512x511-v4sw4m29.png"
                            }
                            alt=""
                          />
                        </div>
                        <h3>{player?.player_name}</h3>
                      </div>
                    );
                  } else {
                    return (
                      <div className="cellsub add_bydef" key={index}>
                        <PlusOutlined />
                      </div>
                    );
                  }
                }
              )}
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};
